module.exports = __webpack_public_path__ + "media/images/patterns/footer-leaf-8dd5b0d66427c07e502c962836a94d5e.svg";